import { render, staticRenderFns } from "./Arweave.vue?vue&type=template&id=77f45534"
import script from "./Arweave.vue?vue&type=script&lang=js"
export * from "./Arweave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports